import { render } from "./controls.vue?vue&type=template&id=36509a3a&scoped=true"
import script from "./controls.vue?vue&type=script&lang=js"
export * from "./controls.vue?vue&type=script&lang=js"

import "./controls.vue?vue&type=style&index=0&id=36509a3a&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36509a3a"]])

export default __exports__